import { render, staticRenderFns } from "./PointCapacityTag.vue?vue&type=template&id=0d508b42&scoped=true&"
import script from "./PointCapacityTag.vue?vue&type=script&lang=js&"
export * from "./PointCapacityTag.vue?vue&type=script&lang=js&"
import style0 from "./PointCapacityTag.vue?vue&type=style&index=0&id=0d508b42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d508b42",
  null
  
)

export default component.exports